import { useState, useEffect, useRef } from 'react';
import { getTodayTheme } from '../data';
import { checkBirthdayPriority } from '../services/birthdayService';

export const useTheme = () => {
  const [theme, setTheme] = useState(null);
  const previousTheme = useRef(null);
  
  useEffect(() => {
    const updateTheme = () => {
      // 1. Önce doğum günü kontrolü yap
      const birthdayCheck = checkBirthdayPriority();
      
      let currentTheme;
      if (birthdayCheck.hasBirthday) {
        // Doğum günü teması en üst öncelik
        currentTheme = birthdayCheck.theme;
      } else {
        // Normal tema sistemi (milli bayram, özel gün, hafta, normal)
        currentTheme = getTodayTheme();
      }
      
      // Sadece tema gerçekten değiştiğinde işlem yap
      if (previousTheme.current?.type !== currentTheme.type || 
          previousTheme.current?.title !== currentTheme.title) {
        
        if (process.env.NODE_ENV === 'development') {
          console.log('🎉 Tema aktif:', currentTheme.type, 'Sevgili Yıldızlarım');
        }
        
        setTheme(currentTheme);
        document.body.setAttribute('data-theme', currentTheme.type);
        previousTheme.current = currentTheme;
      }
    };
    
    // İlk yükleme
    updateTheme();
    
    // Her dakika kontrol et (gece yarısı geçişi için)
    const interval = setInterval(updateTheme, 60000);
    
    return () => clearInterval(interval);
  }, []);
  
  // Her zaman geçerli tema döndür
  if (!theme) {
    const birthdayCheck = checkBirthdayPriority();
    return birthdayCheck.hasBirthday ? birthdayCheck.theme : getTodayTheme();
  }
  return theme;
};